import React, { useRef, useEffect } from 'react';
import "@aurodesignsystem/auro-select";
import { AuthorizationAccessCheck } from "meportal/AuthorizationProvider";
import { CreateButtonFleetType } from "../../../constants/PermissionSet";
import { useEventType } from '../../../providers/EventTypeProvider';
import { useToast } from '../../../providers/ToastProvider';
import { NOTIFICATION_TYPES } from '../../ToastNotification/toastConstants';

interface EventTypeDropdownProps {
  onEventTypeChange: (eventType: string | null, category: string) => void;
}

const EventTypeDropdown: React.FC<EventTypeDropdownProps> = ({ onEventTypeChange }) => {
  const eventTypeRef = useRef(null);
  const [eventType, setEventType] = React.useState<string | null>(null);
  const [isEventTypeValid, setIsEventTypeValid] = React.useState(false);
  const [eventTypeCategory, setEventTypeCategory] = React.useState("");
  const { eventTypes, selectedEventType, isEventTypeHttpError } = useEventType();
  const { addToast } = useToast();

  useEffect(() => {
    const control = eventTypeRef.current;
    const handleSelectedOption = (elem: any) => {
      const selectedValue = elem.target.value;
      setEventType(selectedValue);
      let matchingItem = eventTypes.find(item => item.Name === elem.target.value);
      if (matchingItem) {
        setEventTypeCategory(matchingItem.Category);
        setIsEventTypeValid(true);
        onEventTypeChange(selectedValue, matchingItem.Category);
      }
    };

    if (control) {
       control.addEventListener('selectedOption', handleSelectedOption);
    }

    return () => {
      if (control) {
        control.removeEventListener('selectedOption', handleSelectedOption);
      }
    };
  }, [eventTypes, onEventTypeChange]);

  useEffect(() => {
    if (isEventTypeHttpError) {
      addToast(NOTIFICATION_TYPES.WARNING, 'Unable to load event type.', 'Please try again.');
    }
  }, [isEventTypeHttpError]);

    return (
        <div className="form-input-create">
            <auro-select
                data-testid="event-type-dropdown"
                ref={eventTypeRef}
                placeholder="Event type"
                required
                setCustomValidityValueMissing="An event type selection is required"
                value={eventType}
>
                {eventType && eventType.length > 0 && <span slot="label">Event type</span>}
                <auro-menu>
                    {Array.isArray(eventTypes) &&
                        eventTypes.map((item: any) => (
                            item.IsActive && !item.IsForAirborne ? (
                                <AuthorizationAccessCheck key={item.Name} eventId={item.Airline + ":" + item.Name} permission={CreateButtonFleetType}>
                                    <auro-menuoption
                                        value={item.Name}
                                        id={item.Name}
                                    >
                                        {item.Name}
                                    </auro-menuoption>
                                </AuthorizationAccessCheck>
                            ) : null
                        ))}
                </auro-menu>
            </auro-select>
        </div>
    );
};

export default EventTypeDropdown;